import { Brand } from 'constants/brand';
import { ActivityMetricsService } from './activityMetricsService';

export const ACTIVITY_METRICS_CONFIG = {
  [Brand.FM]: ActivityMetricsService.getFmMetrics(),
  [Brand.GP]: ActivityMetricsService.getGPMetrics(),
  [Brand.DAY1]: ActivityMetricsService.getDay1Metrics(),
};
